export default function SubAbasModulosSisaf(id: string) {
  if (id !== 'undefined') {
    return [
      {
        label: 'Dados Gerais',
        rota: `/daf/adm/modulossiaf/modulo/${id}/dadosgerais`,
      },
    ];
  }

  return [
    {
      label: 'Dados Gerais',
      rota: '/daf/adm/modulossiaf/modulo/dadosgerais',
    },
  ];
}
